(function () {
  angular.module('MktzapApp.Controllers')
    .controller('HandleAttendanceController', handleAttendance);

  handleAttendance.$inject = ['$rootScope', 'FoundationApi', 'HandleAttendanceService', 'NotificationService', 'CompanyService', 'StatusService', 'LangService', 'SectorService'];

  function handleAttendance ($rootScope, FoundationApi, HandleAttendanceService, NotificationService, CompanyService, StatusService, LangService, SectorService) {
    var vm = this;
    vm.handleAttendance = {};
    vm.handleAttendanceData = {};
    vm.sectors = null;
    vm.selectedSector = null;
    vm.selectedCheckbox = [];
    vm.selectedSectors = [];

    SectorService.sectors_with_trashed(function (data) {
      vm.sectors = data.filter(function (item) {
        if (item.deleted_at == null) {
          return true
        }
        return false
      })
    });

    LangService
      .getPageLabels({ 'page': 'menu.master.officeHours' })
      .$promise
      .then(function (data) {
        vm.labelsOfficeHours = data.lang
      })

    function reload () {
      HandleAttendanceService
        .all()
        .$promise
        .then(function (data) {
          vm.handleAttendanceData = data;
        }).catch(function (data) {
          NotificationService.errorHandler(data, $rootScope.labels.errorListHandleAttendance);
        });

    	    CompanyService
        .find(
          { id: $rootScope.user_data.company_id }
        )
        .$promise
        .then(function (data) {
          vm.company = data;
          if (!vm.handleAttendance) {
            vm.handleAttendance = {};
            vm.handleAttendance.company_id = vm.company.id;
          }
        })
        .catch(function (error) {
          NotificationService.errorHandler(error, $rootScope.labels.requestError);
        });

      StatusService
        .should_close_statuses()
        .$promise
        .then(function (data) {
          vm.shouldCloseStatuses = data;
        })
        .catch(function (error) {
          NotificationService.errorHandler(error, $rootScope.labels.requestError);
        });
    }
    reload();

    vm.addHandleAttendanceConfig = function () {
      vm.handleAttendance = {};
      FoundationApi.publish('addHandleAttendanceModal', 'open');
    }

    vm.editHandleAttendanceConfig = function (handleAttendance_id) {
      HandleAttendanceService
        .findOne({ id: handleAttendance_id })
        .$promise
        .then(function (data) {
          vm.handleAttendance = data;
          vm.channel_type = vm.handleAttendance.channel_type;
          vm.selectedSectors = vm.handleAttendance.sectors;
          populateSelectedCheckbox();
          FoundationApi.publish('addHandleAttendanceModal', 'open');
        })
        .catch(function (error) {
          NotificationService.errorHandler(error, $rootScope.labels.requestError);
        });
    }

    vm.deleteHandleAttendance = function (handleAttendance, index) {
      FoundationApi.publish('confirmDeleteModal', 'close');

      HandleAttendanceService
        .delete(
          { id: vm.deleting.id }
        )
        .$promise
        .then(function (data) {
          NotificationService.successHandler(data, $rootScope.labels.successDelData);
          reload();
        })
        .catch(function (error) {
          NotificationService.errorHandler(error, $rootScope.labels.requestError);
        });
    }

    vm.saveHandleAttendanceConfig = function (handleAttendance) {
      vm.handleAttendance = handleAttendance
      vm.handleAttendance.channel_type = vm.channel_type

      if (!vm.handleAttendance.extra_params) {
        vm.handleAttendance.extra_params = {};
      }

      if (vm.handleAttendance.extra_params.shouldUseSectors) {
        vm.handleAttendance.extra_params.sectors = vm.selectedSectors;
      } else {
        vm.handleAttendance.extra_params.sectors = [];
      }

      if (!(vm.selectedSectors.length > 0) && vm.handleAttendance.extra_params.shouldUseSectors) {
        NotificationService.warningHandler(null, vm.labelsOfficeHours.selectSector);
        return;
      }

      if (vm.handleAttendance.id === undefined) {
        HandleAttendanceService
          .create(
            {},
            handleAttendance
          )
          .$promise
          .then(function (data) {
            NotificationService.successHandler(data, $rootScope.labels.savedWithSuccess);
            FoundationApi.publish('addHandleAttendanceModal', 'close');
            reload();
          })
          .catch(function (error) {
            NotificationService.errorHandler(error, error.message);
          });
      } else {
        HandleAttendanceService
          .update(
            { id: vm.handleAttendance.id },
            handleAttendance
          )
          .$promise
          .then(function (data) {
            NotificationService.successHandler(data, $rootScope.labels.updatedWithSuccess);
            FoundationApi.publish('addHandleAttendanceModal', 'close');
            reload();
          })
          .catch(function (error) {
            NotificationService.errorHandler(error, error.message);
          });
      }
    }

    vm.confirmDelete = function (handleAttendance) {
      vm.deleting = handleAttendance
      FoundationApi.publish('confirmDeleteModal', 'open');
    }

    vm.changeAction = function () {
      if (vm.handleAttendance.action != 'closeAttendance') {
        vm.handleAttendance.should_close_status_id = '';
      }

      if (vm.handleAttendance.action != 'startChat') {
        vm.handleAttendance.sector_id = '';
      }
    }

    vm.addSectorInSelected = function (sector) {
      let found = vm.selectedSectors.find(element => {
        return element === sector.id
      })

      if (!found) {
        vm.selectedSectors.push(sector.id)
        return true
      }

      let index = vm.selectedSectors.indexOf(sector.id)

      if (index > -1) {
        vm.selectedSectors.splice(index, 1)
        return false
      }
    }

    function checkIfSectorIsInUse (id) {
      let handleAttendanceFounded = null
      let sectorHandleAttendance = null

      vm.handleAttendanceData.forEach((value, index) => {
        handleAttendanceFounded = value.sectors.find(function (element) {
          return element === id
        })

        if (handleAttendanceFounded) {
          sectorHandleAttendance = value
        }
      })

      if (sectorHandleAttendance && typeof vm.handleAttendance.id === 'undefined') {
        NotificationService.warningHandler(null, vm.labelsOfficeHours.sectorAlreadyInUse)
        vm.selectedCheckbox[handleAttendanceFounded] = false
        return true
      }

      if (
        sectorHandleAttendance &&
        sectorHandleAttendance.id !== vm.handleAttendance.id
      ) {
        NotificationService.warningHandler(null, vm.labelsOfficeHours.sectorAlreadyInUse)
        vm.selectedCheckbox[handleAttendanceFounded] = false
        return true
      }

      return false
    }

    function populateSelectedCheckbox () {
      vm.sectors.forEach((item) => {
        vm.selectedCheckbox[item.id] = vm.checkIsChecked(item.id)
      })
    }

    vm.checkIsChecked = function (id) {
      let found = vm.selectedSectors.find(element => {
        return element === id
      })

      if (found) {
        return true
      }

      return false
    }
  }
})();
